module.exports = __webpack_public_path__ + "media/images/weather/104_night-5fa7053d2a7e662136045a1ff5d9bb5a.png";